import React from "react";
import Hero from "../components/Hero";
// import Loader from "../components/Loader";
import "./Home.css";

import About from "./About";
import Projects from "./Projects";
import Contact from "./Contact";

import {
  DiReact,
  DiJavascript1,
  DiHtml5,
  DiCss3,
  DiBootstrap,
  DiNodejs,
  DiNodejsSmall,
  DiMongodb,
} from "react-icons/di";
import {
  SiFirebase,
  SiTypescript,
  SiJavascript,
  SiAngular,
} from "react-icons/si";

export default function Home() {
  return (
    <>
      {/* <Loader /> */}
      <div className="full-page">
        <div className="home-container">
          <div className="home-wrap" id="home">
            {/* <div></div> */}
            <div className="avatar-wrap">
              {/* <Avatar /> */}

              <img className="avatar" src="codejd.svg" alt="Jan avatar" />
            </div>
            <div className="hero-wrap">
              <Hero />
            </div>
            <div></div>
          </div>

          <div className="home-tech">
            <div className="tech-title">Works with multiple technologies</div>
            <div className="tech-tech">
              <span id="tech-react">
                <DiReact />
              </span>
              <span id="tech-ts">
                <SiTypescript />
              </span>
              <span id="tech-js">
                <SiJavascript />
              </span>
              <span id="tech-angular">
                <SiAngular />
              </span>
              <span id="tech-node">
                <DiNodejsSmall />
              </span>
              <span id="tech-ex">
                <span>ex</span>
              </span>
              <span id="tech-mongo">
                <DiMongodb />
              </span>
              <span id="tech-fire">
                <SiFirebase />
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
